// Exports
export default {
	"empty": "empty_F1GHi",
	"isSafariBased": "isSafariBased_G8R6Z"
};
